import { useMemo } from 'react'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  return useMemo(() => {
    if (!data) return data

    return data.map(item => ({
      ...item.task,
      priority:
        (item.task?.priority &&
          item.task.priority.charAt(0).toUpperCase() +
            item.task.priority.slice(1)) ||
        null,
      patient_name: item.patient_name,
      comments_count: item.comments_aggregate_count,
      logs_count: item.logs_aggregate_count,
      patient: item.task.patients?.[0],
      assignee: item.task.assignees?.[0],
    }))
  }, [data])
}
